import { render, staticRenderFns } from "./ATemplateContratoEsp.vue?vue&type=template&id=6af3ed60"
import script from "./ATemplateContratoEsp.vue?vue&type=script&lang=js"
export * from "./ATemplateContratoEsp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports